export default {
  noImage: 'https://s3-ap-southeast-1.amazonaws.com/teachpot/default/404-img.png',
};

export const noImage = 'https://s3-ap-southeast-1.amazonaws.com/teachpot/default/404-img.png';
